import { render } from "./OtherRequests.vue?vue&type=template&id=f3d47318"
import script from "./OtherRequests.vue?vue&type=script&lang=js"
export * from "./OtherRequests.vue?vue&type=script&lang=js"

import "./OtherRequests.vue?vue&type=style&index=0&id=f3d47318&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__